import { render, staticRenderFns } from "./EditCollaboratorModal.vue?vue&type=template&id=20b138b0&"
import script from "./EditCollaboratorModal.vue?vue&type=script&lang=js&"
export * from "./EditCollaboratorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports